import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-carbon py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-243" data-mp="j76u8n3d81qc">
      <div className="mx-auto max-w-4xl px-4" data-id="element-244" data-mp="j53w1fs272aj">
        <SectionHeading id="summary-title" data-id="element-245" data-mp="1gv71z2b2pw5y">Everything included:</SectionHeading>
        <p className="mt-4 text-center text-muted" data-id="element-246" data-mp="1bw417u24mc3s">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-energy" data-id="element-247" data-mp="16vgcxg5a89d9">{price}</b>
        </p>

        <ul className="mt-10 grid overflow-hidden rounded-2xl border border-lava/30 bg-petrol sm:grid-cols-2" data-id="element-248" data-mp="12vpb8he7w8ty">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 border-b border-white/10 p-4 sm:odd:border-r" data-id="element-249" data-mp="3rkvvxoy9etsc">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-lava" data-id="element-250" data-mp="3nnhlxv2r8hza">
                <CheckIcon className="h-3.5 w-3.5 text-carbon" aria-hidden="true" data-id="element-251" data-mp="3nbzanntmyugi" />
              </span>
              <p data-id="element-252" data-mp="39c81c0e2e28u">
                <b className="block text-sm text-snow" data-id="element-253" data-mp="39cr9ipdwxc9o">{feature}</b>
                <span className="text-sm text-muted" data-id="element-254" data-mp="39ekfe2gpbsgm">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-2xl border-l-4 border-energy bg-petrol px-6 py-5 text-center text-lg font-bold leading-relaxed text-snow" data-id="element-255" data-mp="2zlwmhisue8n6">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}